// extracted by mini-css-extract-plugin
export default {"container":"chat-id_container__wUNE+","--extended":"chat-id_--extended__DlLVF"};